import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { CommunicationsService } from "../../../../auth/service/communications.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../auth/service";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FlatpickrOptions } from "ng2-flatpickr";
import Italian from "flatpickr/dist/l10n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-send-communication",
  templateUrl: "./form-communication.component.html",
  styleUrls: ["./form-communication.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FormCommunicationComponent implements OnInit {
  public basicDateOptions: FlatpickrOptions;
  public me: ICurrentUser;
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public showErrors: boolean = false;
  public users_list: any = [];
  public communicationID: any;
  public isEditMode: boolean = false;
  public currentCommunication: any;
  public categoriesList: any = [];

  constructor(
    public _communicationService: CommunicationsService,
    private _formBuilder: FormBuilder,
    public _userService: UserService,
    public _utilService: UtilsService,
    public _routerService: Router,
    public _activatedRoute: ActivatedRoute,
    public _authenticationService: AuthenticationService,
  ) {
    this.formGroup = this._formBuilder.group({
      title: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      category: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      send_date: new FormControl(moment().format("YYYY-MM-DD"), [Validators.required]),
      send_to_users: new FormControl([]),
      send_to_groups: new FormControl(""),
      text: new FormControl("", [Validators.required, Validators.minLength(2)]),
      time: {
        hour: moment().hour(),
        minute: moment().minute(),
      },
    });
    this._activatedRoute.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        this.isEditMode = true;
        this.communicationID = Number(params.id);
        this.currentCommunication = await this._communicationService.getCommunication(this.communicationID);
        this.formGroup.patchValue({ title: this.currentCommunication.title });
        this.formGroup.patchValue({ category: this.currentCommunication.category_id });
        if (this.currentCommunication.groups.length > 0) {
          this.formGroup.patchValue({ send_to_groups: this.currentCommunication.groups.map((item) => item.id) });
          this.formGroup.patchValue({ send_to_users: null });
        } else {
          this.formGroup.patchValue({ send_to_users: this.currentCommunication.users.map((item) => item.user_hash) });
          this.formGroup.patchValue({ send_to_groups: null });
        }
        this.formGroup.patchValue({ send_date: this.currentCommunication.send_date });
        this.formGroup.patchValue({
          time: {
            hour: Number(this.currentCommunication.send_date.slice(11, 13)),
            minute: Number(this.currentCommunication.send_date.slice(14, 16)),
          },
        });

        this.formGroup.patchValue({ text: this.currentCommunication.text });
        this.basicDateOptions = {
          altFormat: "d/m/Y",
          defaultDate: moment(this.formGroup.value.send_date).format("YYYY-MM-DD"),
          locale: Italian.it,
          altInput: true,
          utc: true,
          minDate: "today",
          disableMobile: true,
        };
      } else {
        this.basicDateOptions = {
          altFormat: "d/m/Y",
          defaultDate: moment().format("YYYY-MM-DD"),
          locale: Italian.it,
          altInput: true,
          utc: true,
          minDate: "today",
          disableMobile: true,
        };
      }
    });
    this.contentHeader = {
      headerTitle: this.isEditMode ? "MENU.EDIT_COMMUNICATION" : "MENU.SEND_COMMUNICATION",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: this.isEditMode ? "MENU.EDIT_COMMUNICATION" : "MENU.SEND_COMMUNICATION",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = await this._authenticationService.getCurrentUser();
    this.categoriesList = await this._communicationService.getListCategories();
    this.categoriesList = this.categoriesList
      .map((item: any) => {
        const hasMyRole = item.roles.filter((role) => role.id == this.me.role_id);
        if (hasMyRole.length > 0) {
          return item;
        }
        return null;
      })
      .filter((item: any) => item);
    this.users_list = await this._userService.getList("employee", null, false, "complete_name,hash,send_onboarding")
      .then((response: any) => (response || []).filter((item: any) => Boolean(item.send_onboarding)));
  }

  fieldHasErrors(field_name: string): boolean {
    return (this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched) || this.showErrors;
  }

  handlerChangeData(event: any) {
    this.formGroup.patchValue({ send_date: event.target.value });
  }

  async update() {
    if (!this._authenticationService.hasCapability("edit_notification")) {
      window.history.back();
      return false;
    }
    // if (this.formGroup.value.title.length < 1 || this.formGroup.value.text?.length < 1 || this.formGroup.value.category.length < 1 || this.formGroup.value.send_date.length < 1) {
    //     await this._utilService.showSWALError({text: 'ERROR_EMPTY_FIELDS'})
    //     return false
    // }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid && !this.isEditMode) {
      return false;
    }
    const day: any = moment(this.formGroup.value.send_date);

    day.set("hour", this.formGroup.value.time.hour);
    day.set("minute", this.formGroup.value.time.minute);
    let data = {
      title: this.formGroup.value.title,
      category: this.formGroup.value.category,
      via: "email",
      send_date: moment(day).format("YYYY-MM-DD HH:mm:00"),
      send_to_users: this.formGroup.value.send_to_users || [],
      send_to_groups: this.formGroup.value.send_to_groups || [],
      text: this.formGroup.value.text,
    };
    if (data.send_to_users.length < 1 && data.send_to_groups.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      return false;
    }
    const today = moment().format("YYYY-MM-DD HH:mm:00");
    if (data.send_date < today) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }
    this._utilService.showLoading();
    await this._communicationService
      .update(this.communicationID, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_COMMUNICATION" }).then(() => this._routerService.navigateByUrl("dashboard/communications-list"));
      })
      .catch(async () => {
        await this._utilService.showSWALError({ text: "ERROR_UPDATE_COMMUNICATION" });
        await this._utilService.hideLoading();
      });
  }

  async sendCommunication() {
    if (!this._authenticationService.hasCapability("create_notification")) {
      window.history.back();
      return false;
    }
    // if (this.formGroup.invalid || !this.formGroup.value.text) {
    //     await this._utilService.showSWALError({text: 'ERROR_EMPTY_FIELDS'})
    //     return false
    // }
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid && !this.isEditMode) {
      if (
        (!this.formGroup?.value?.send_to_groups && this.formGroup?.value?.send_to_users && this.formGroup?.value?.send_to_users?.length < 1 && this.formGroup?.value?.send_to_groups?.length < 1) ||
        (this.formGroup?.value?.send_to_users == null && this.formGroup?.value?.send_to_groups?.length < 1)
      ) {
        await this._utilService.showSWALError({ text: "ERROR_INSERT_USER" });
        return false;
      }
      return false;
    }
    const day: any = moment(this.formGroup.value.send_date);

    day.set("hour", this.formGroup.value.time.hour);
    day.set("minute", this.formGroup.value.time.minute);

    let data = {
      title: this.formGroup.value.title,
      category: this.formGroup.value.category,
      via: "email",
      send_date: moment(day).format("YYYY-MM-DD HH:mm:00"),
      send_to_users: this.formGroup.value.send_to_users || null,
      send_to_groups: this.formGroup.value.send_to_groups || null,
      text: this.formGroup.value.text,
    };
    const today = moment().format("YYYY-MM-DD HH:mm:00");
    if (data.send_date < today) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }

    this._utilService.showLoading();
    await this._communicationService
      .create(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService
          .showSWALSuccess({ text: "SUCCESS_SEND_COMMUNICATION" })
          .then(() => this._routerService.navigateByUrl("dashboard/communications-list"))
          .then(() => this._utilService.hideLoading());
      })
      .catch(async () => {
        await this._utilService.showSWALError({ text: "ERROR_SEND_COMMUNICATION" });
        this._utilService.hideLoading;
      });
  }

  selectAllUsers() {
    this.formGroup.patchValue({ send_to_users: this.users_list.map((item: any) => item.hash) });
  }

  unselectUsers() {
    this.formGroup.patchValue({ send_to_users: [] });
  }
}
